export const TAB_NAME_NOTIFICATIONS: string = 'notifications';
export const TAB_NAME_SUMMARY: string = 'summary';
export const TAB_NAME_COMMENTS: string = 'comments';
export const TAB_NAME_LOCATION_INFORMATION: string = 'location-information';
export const TAB_NAME_PROPERTY_INFORMATION: string = 'property-information';
export const TAB_NAME_PROPERTY_CAPITALIZATION: string = 'property-capitalization';
export const TAB_NAME_OWNERSHIP_INFORMATION: string = 'ownership-information';
export const TAB_NAME_INVESTMENT_INFORMATION: string = 'investment-information';
export const TAB_NAME_INVESTMENT_PERFORMANCE: string = 'investment-performance';
export const TAB_NAME_PROPERTY_PERFORMANCE: string = 'property-performance';
export const TAB_NAME_MANAGEMENT_FEE_INFORMATION: string = 'management-fee-information';
export const TAB_NAME_OTHER: string = 'other';
export const TAB_NAME_ALLOCATION: string = 'allocation';
export const TAB_NAME_ASSOCIATED_DEALS: string = 'linked-deals';
export const TAB_NAME_CAPITALIZATION: string = 'capitalization';
export const TAB_NAME_DEAL_TERMS: string = 'deal-terms';
export const TAB_NAME_PRO_FORMA: string = 'pro-forma';
export const TAB_NAME_DUE_DILIGENCE: string = 'due-diligence';
export const TAB_NAME_SCHEDULE: string = 'schedule';
export const TAB_NAME_PARTICIPANTS: string = 'participants';
export const TAB_NAME_DEAL_FILES: string = 'deal-files';
export const TAB_NAME_DEAL_ACTIVITY: string = 'deal-activity';
export const TAB_NAME_DEAL_COMMENTS: string = 'deal-comments';
export const TAB_NAME_DEAL_LIST_TYPES: string = 'deal-list-types';
export const TAB_NAME_ACCOUNT_ADMINISTRATION: string = 'account-administration';
export const TAB_NAME_ACCOUNT: string = 'account';
export const TAB_NAME_DEAL_TEMPLATES: string = 'deal-templates';
export const TAB_NAME_PORTFOLIO_MANAGEMENT: string = 'portfolio-management';
export const TAB_NAME_AUDIT_LOG: string = 'audit-log';
export const TAB_NAME_USERS: string = 'users';
export const TAB_NAME_PROFILE: string = 'profile';
export const TAB_NAME_SECURITY: string = 'security';
export const TAB_NAME_GENERAL: string = 'general';
export const TAB_NAME_PREFERENCES: string = 'preferences';
export const TAB_NAME_OKTA: string = 'okta';
export const TAB_NAME_YARDI: string = 'yardi';
export const TAB_NAME_POWER_BI: string = 'power-bi';
export const TAB_NAME_AZURE: string = 'azure';
export const TAB_NAME_WIDGETS: string = 'widgets';
export const TAB_NAME_STATISTIC_ITEMS: string = 'statistic-items';
export const TAB_NAME_DEAL_STATUSES: string = 'deal-statuses';
export const TAB_NAME_DEAL_TASK_STATUSES: string = 'deal-task-statuses';
export const TAB_NAME_ACTIVITY_STATUSES: string = 'activity-statuses';
export const TAB_NAME_DEAD_DEAL_REASONS: string = 'dead-deal-reasons';
export const TAB_NAME_PORTFOLIO_LIST: string = 'portfolio-list';
export const TAB_NAME_ACCOUNT_ACTIVITY: string = 'account-activity';
export const TAB_NAME_USER_OPERATIONS: string = 'user-operations';
export const TAB_NAME_EMAIL_OPERATIONS: string = 'email-operations';
export const TAB_NAME_DEAL_OPERATIONS: string = 'deal-operations';
export const TAB_NAME_API_OPERATIONS: string = 'api-operations';
export const TAB_NAME_REPORT_OPERATIONS: string = 'report-operations';
export const TAB_NAME_ERROR_MESSAGES: string = 'error-messages';
export const TAB_NAME_EMAIL_NOTIFICATIONS: string = 'email-notifications';
export const TAB_NAME_INTERNAL_NOTIFICATIONS: string = 'internal-notifications';
export const TAB_NAME_INTERNAL_COMMENTS: string = 'internal-comments';
